/**
 * PDF Export Utility
 * Creates PDF files from HTML elements using html2canvas and jsPDF
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
/**
 * Export an HTML element to PDF
 */
export var exportToPDF = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var targetElement, originalDisplay, elementRect, canvasOptions, canvas, imgData, pdfWidth, pdfHeight, pageDimensions, dimensions, pdf, contentWidth, contentHeight, imgWidth, imgHeight, imgRatio, contentRatio, finalWidth, finalHeight, x, y, finalFilename, timestamp;
    var filename = _b.filename, element = _b.element, _c = _b.orientation, orientation = _c === void 0 ? "landscape" : _c, _d = _b.format, format = _d === void 0 ? "a4" : _d, _e = _b.quality, quality = _e === void 0 ? 0.95 : _e, _f = _b.scale, scale = _f === void 0 ? 2 : _f, _g = _b.margins, margins = _g === void 0 ? { top: 10, right: 10, bottom: 10, left: 10 } : _g, customDimensions = _b.customDimensions, _h = _b.addTimestamp, addTimestamp = _h === void 0 ? true : _h;
    return __generator(this, function (_j) {
        switch (_j.label) {
            case 0:
                targetElement = null;
                if (typeof element === "string") {
                    // Try to find by ID first, then by class, then by querySelector
                    targetElement =
                        document.getElementById(element) || document.querySelector(".".concat(element)) || document.querySelector(element);
                }
                else {
                    targetElement = element;
                }
                if (!targetElement) {
                    throw new Error("Element not found: ".concat(element));
                }
                originalDisplay = targetElement.style.display;
                if (getComputedStyle(targetElement).display === "none") {
                    targetElement.style.display = "block";
                }
                elementRect = targetElement.getBoundingClientRect();
                canvasOptions = {
                    scale: scale,
                    useCORS: true,
                    allowTaint: true,
                    backgroundColor: "#ffffff",
                    width: elementRect.width,
                    height: elementRect.height,
                    scrollX: 0,
                    scrollY: 0,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight,
                };
                return [4 /*yield*/, html2canvas(targetElement, canvasOptions)];
            case 1:
                canvas = _j.sent();
                // Restore original display style
                if (originalDisplay !== targetElement.style.display) {
                    targetElement.style.display = originalDisplay;
                }
                imgData = canvas.toDataURL("image/jpeg", quality);
                if (customDimensions) {
                    pdfWidth = customDimensions.width;
                    pdfHeight = customDimensions.height;
                }
                else {
                    pageDimensions = {
                        a4: { width: 210, height: 297 },
                        letter: { width: 216, height: 279 },
                        legal: { width: 216, height: 356 },
                    };
                    dimensions = pageDimensions[format];
                    if (orientation === "landscape") {
                        pdfWidth = dimensions.height;
                        pdfHeight = dimensions.width;
                    }
                    else {
                        pdfWidth = dimensions.width;
                        pdfHeight = dimensions.height;
                    }
                }
                pdf = new jsPDF({
                    orientation: orientation,
                    unit: "mm",
                    format: format,
                });
                contentWidth = pdfWidth - (margins.left || 0) - (margins.right || 0);
                contentHeight = pdfHeight - (margins.top || 0) - (margins.bottom || 0);
                imgWidth = canvas.width;
                imgHeight = canvas.height;
                imgRatio = imgWidth / imgHeight;
                contentRatio = contentWidth / contentHeight;
                if (imgRatio > contentRatio) {
                    // Image is wider relative to content area
                    finalWidth = contentWidth;
                    finalHeight = contentWidth / imgRatio;
                }
                else {
                    // Image is taller relative to content area
                    finalHeight = contentHeight;
                    finalWidth = contentHeight * imgRatio;
                }
                x = (margins.left || 0) + (contentWidth - finalWidth) / 2;
                y = (margins.top || 0) + (contentHeight - finalHeight) / 2;
                // Add image to PDF
                pdf.addImage(imgData, "JPEG", x, y, finalWidth, finalHeight);
                finalFilename = filename;
                if (addTimestamp) {
                    timestamp = new Date().toISOString().slice(0, 19).replace(/[:.]/g, "-");
                    finalFilename = "".concat(filename, "_").concat(timestamp);
                }
                finalFilename += ".pdf";
                // Save the PDF
                pdf.save(finalFilename);
                return [2 /*return*/];
        }
    });
}); };
/**
 * Export multiple HTML elements to a single PDF (each element on its own page)
 */
export var exportMultipleElementsToPDF = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var pdfWidth, pdfHeight, pageDimensions, dimensions, pdf, contentWidth, contentHeight, i, element, progressPercent, targetElement, originalDisplay, elementRect, canvasOptions, canvas, imgData, imgWidth, imgHeight, imgRatio, contentRatio, finalWidth, finalHeight, x, y, finalFilename, timestamp;
    var filename = _b.filename, elements = _b.elements, _c = _b.orientation, orientation = _c === void 0 ? "landscape" : _c, _d = _b.format, format = _d === void 0 ? "a4" : _d, _e = _b.quality, quality = _e === void 0 ? 0.95 : _e, _f = _b.scale, scale = _f === void 0 ? 2 : _f, _g = _b.margins, margins = _g === void 0 ? { top: 10, right: 10, bottom: 10, left: 10 } : _g, customDimensions = _b.customDimensions, _h = _b.addTimestamp, addTimestamp = _h === void 0 ? true : _h, onProgress = _b.onProgress, signal = _b.signal;
    return __generator(this, function (_j) {
        switch (_j.label) {
            case 0:
                if (!elements || elements.length === 0) {
                    throw new Error("No elements provided for export");
                }
                // Check for cancellation
                if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
                    throw new Error("Export cancelled");
                }
                onProgress === null || onProgress === void 0 ? void 0 : onProgress(0, "Initializing PDF export...");
                if (customDimensions) {
                    pdfWidth = customDimensions.width;
                    pdfHeight = customDimensions.height;
                }
                else {
                    pageDimensions = {
                        a4: { width: 210, height: 297 },
                        letter: { width: 216, height: 279 },
                        legal: { width: 216, height: 356 },
                    };
                    dimensions = pageDimensions[format];
                    if (orientation === "landscape") {
                        pdfWidth = dimensions.height;
                        pdfHeight = dimensions.width;
                    }
                    else {
                        pdfWidth = dimensions.width;
                        pdfHeight = dimensions.height;
                    }
                }
                pdf = new jsPDF({
                    orientation: orientation,
                    unit: "mm",
                    format: format,
                });
                contentWidth = pdfWidth - (margins.left || 0) - (margins.right || 0);
                contentHeight = pdfHeight - (margins.top || 0) - (margins.bottom || 0);
                i = 0;
                _j.label = 1;
            case 1:
                if (!(i < elements.length)) return [3 /*break*/, 4];
                // Check for cancellation before processing each element
                if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
                    throw new Error("Export cancelled");
                }
                element = elements[i];
                progressPercent = Math.round((i / elements.length) * 90);
                onProgress === null || onProgress === void 0 ? void 0 : onProgress(progressPercent, "Processing card ".concat(i + 1, " of ").concat(elements.length, "..."));
                targetElement = null;
                if (typeof element === "string") {
                    targetElement =
                        document.getElementById(element) || document.querySelector(".".concat(element)) || document.querySelector(element);
                }
                else {
                    targetElement = element;
                }
                if (!targetElement) {
                    // console.warn(`Element not found, skipping: ${element}`);
                    return [3 /*break*/, 3];
                }
                originalDisplay = targetElement.style.display;
                if (getComputedStyle(targetElement).display === "none") {
                    targetElement.style.display = "block";
                }
                elementRect = targetElement.getBoundingClientRect();
                canvasOptions = {
                    scale: scale,
                    useCORS: true,
                    allowTaint: true,
                    backgroundColor: "#ffffff",
                    width: elementRect.width,
                    height: elementRect.height,
                    scrollX: 0,
                    scrollY: 0,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight,
                };
                return [4 /*yield*/, html2canvas(targetElement, canvasOptions)];
            case 2:
                canvas = _j.sent();
                // Restore original display style
                if (originalDisplay !== targetElement.style.display) {
                    targetElement.style.display = originalDisplay;
                }
                imgData = canvas.toDataURL("image/jpeg", quality);
                // Add new page for each element (except the first one)
                if (i > 0) {
                    pdf.addPage();
                }
                imgWidth = canvas.width;
                imgHeight = canvas.height;
                imgRatio = imgWidth / imgHeight;
                contentRatio = contentWidth / contentHeight;
                finalWidth = void 0, finalHeight = void 0;
                if (imgRatio > contentRatio) {
                    // Image is wider relative to content area
                    finalWidth = contentWidth;
                    finalHeight = contentWidth / imgRatio;
                }
                else {
                    // Image is taller relative to content area
                    finalHeight = contentHeight;
                    finalWidth = contentHeight * imgRatio;
                }
                x = (margins.left || 0) + (contentWidth - finalWidth) / 2;
                y = (margins.top || 0) + (contentHeight - finalHeight) / 2;
                // Add image to PDF
                pdf.addImage(imgData, "JPEG", x, y, finalWidth, finalHeight);
                _j.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4:
                // Check for cancellation before final save
                if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
                    throw new Error("Export cancelled");
                }
                onProgress === null || onProgress === void 0 ? void 0 : onProgress(95, "Generating PDF file...");
                finalFilename = filename;
                if (addTimestamp) {
                    timestamp = new Date().toISOString().slice(0, 19).replace(/[:.]/g, "-");
                    finalFilename = "".concat(filename, "_").concat(timestamp);
                }
                finalFilename += ".pdf";
                onProgress === null || onProgress === void 0 ? void 0 : onProgress(100, "Saving PDF file...");
                // Save the PDF
                pdf.save(finalFilename);
                return [2 /*return*/];
        }
    });
}); };
/**
 * Utility function to prepare an element for PDF export
 * (e.g., temporarily show hidden elements, adjust styles)
 */
export var prepareElementForPDFExport = function (element) {
    var originalStyles = new Map();
    // Store original display styles and make elements visible
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_ELEMENT, null);
    var node;
    while ((node = walker.nextNode())) {
        var el = node;
        var computedStyle = getComputedStyle(el);
        if (computedStyle.display === "none") {
            originalStyles.set(el, el.style.display);
            el.style.display = "block";
        }
    }
    // Return cleanup function
    return function () {
        originalStyles.forEach(function (originalDisplay, el) {
            el.style.display = originalDisplay;
        });
    };
};
// Default export
export default exportToPDF;
